import { toQueryParams } from '@shared/utils/url';
import { v1 } from '@/api/client';

export const fetchPrices = async (
  ids: number[],
  deliveryPointId: string
): Promise<PriceAndAvailability[]> => {
  const params = toQueryParams({
    item_ids: ids,
    delivery_point_id: deliveryPointId,
  });
  const prices = await v1.get<PriceAndAvailabilityDto[]>(
    `ecom/catalog/article/priceandavailability${params}`
  );
  return prices.map((price) => ({ ...price, deliveryPointId }));
};
